// extracted by mini-css-extract-plugin
module.exports = {"backgrounder":"backgrounder_backgrounder__3rErJ"};